/** A cached checkout page returned; this does not indicate whether payment completed. */
export class CheckoutReturnedError extends Error {
  constructor() {
    super('Returned from Stripe Checkout.');
    this.name = 'CheckoutReturnedError';
  }
}
